import React, { Component, type ReactElement } from 'react'
import './style.css'

class DevWatermark extends Component {
  render(): ReactElement | null {
    if (process.env.REACT_APP_ENV !== 'dev') {
      return null
    }

    const marks = Array.from({ length: 36 }, (_, index) => (
      <span key={index} className='dev-watermark-text'>
        DEV
      </span>
    ))

    return (
      <div className='dev-watermark' aria-hidden>
        <div className='dev-watermark-grid'>{marks}</div>
      </div>
    )
  }
}

export default DevWatermark
